<template>
  <div class="gallery-card1-gallery-card" v-bind:class="rootClassName">
    <img :alt="imageAlt" :src="imageSrc" class="gallery-card1-image" />
    <h2 class="gallery-card1-text1">{{ title }}</h2>
    <span class="gallery-card1-text2">{{ subtitle }}</span>
  </div>
</template>

<script>
export default {
  name: 'GalleryCard1',
  props: {
    title: {
      type: String,
      default: 'Project Title',
    },
    imageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDEyfHxmb3Jlc3R8ZW58MHx8fHwxNjI2MjUxMjg4&ixlib=rb-1.2.1&h=1200',
    },
    imageAlt: {
      type: String,
      default: 'image',
    },
    rootClassName: String,
    subtitle: {
      type: String,
      default: 'Lorem ipsum dolor sit amet',
    },
  },
}
</script>

<style scoped>
.gallery-card1-gallery-card {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.gallery-card1-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gallery-card1-text1 {
  align-self: flex-start;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
.gallery-card1-text2 {
  color: var(--dl-color-gray-500);
  align-self: flex-start;
}



.gallery-card1root-class-name3 {
  width: 100%;
}
.gallery-card1root-class-name4 {
  width: 100%;
}
.gallery-card1root-class-name5 {
  width: 100%;
}
.gallery-card1root-class-name6 {
  width: 100%;
}
.gallery-card1root-class-name7 {
  width: 100%;
}
.gallery-card1root-class-name8 {
  width: 100%;
}



.gallery-card1root-class-name12 {
  width: 100%;
}
.gallery-card1root-class-name13 {
  width: 100%;
}
.gallery-card1root-class-name14 {
  width: 100%;
}
.gallery-card1root-class-name15 {
  width: 100%;
}
.gallery-card1root-class-name16 {
  width: 100%;
}
.gallery-card1root-class-name17 {
  width: 100%;
}



.gallery-card1root-class-name21 {
  width: 100%;
}
.gallery-card1root-class-name22 {
  width: 100%;
}
.gallery-card1root-class-name23 {
  width: 100%;
}
.gallery-card1root-class-name24 {
  width: 100%;
}
.gallery-card1root-class-name25 {
  width: 100%;
}
.gallery-card1root-class-name26 {
  width: 100%;
}
@media(max-width: 767px) {
  .gallery-card1-gallery-card {
    flex-direction: column;
  }
}
@media(max-width: 479px) {
  .gallery-card1-image {
    height: 10rem;
  }
}
</style>
